export const PERSISTENCE_DELAY_MS = 1000;

export const initialDialog = { show: false, icon: '', title: '', text: '', actionType: null };
export const initialToast = { show: false, type: '', message: '' };
export const initialUserDetailsModal = {
	show: false,
	mode: 'view',
	user: null,
	itemType: 'titular',
};
